import * as React from 'react'
import { getPaymentsTable } from '../../../Model/Payment'
import { observer, inject } from 'mobx-react'
import ExportToCsvComponent from '../../../Components/ExportToCsvComponent'
import { ExportType } from '../../../Stores/ExportStore'
import PageSizeComponent from '../../../Components/PageSizeComponent'
import LocalizationStore from '../../../Stores/LocalizationStore'

export interface IPaymentsPageProps {
    localizationStore?: LocalizationStore
}
@inject('localizationStore')
@observer
export default class PaymentsPage extends React.Component<IPaymentsPageProps> {
    render() {
        const { localizationStore } = this.props

        return (
            <div className="paymentsPage row page">
                <div className="col-12">
                    <h4>{localizationStore!.t('PaymentsPageHeader')}</h4>
                </div>
                <div className="col-12">
                    <PageSizeComponent />
                    <ExportToCsvComponent exportType={ExportType.Payments} />
                    {getPaymentsTable()}
                </div>
            </div>
        )
    }
}


// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/Views/Pages/Payment/PaymentsPage.tsx